import Vue from "vue";

Vue.mixin({
    methods: {
        popupVideo(videoId) {
            const getVideoIDAndParameterString = url => {
                const t = document.createElement('textarea');
                t.innerHTML = url;
                const decodedUrl = t.value;

                let videoid = '';
                let urlParameter = '';
                let matchedResult;

                if (matchedResult = decodedUrl.match(/(?:[?&]v=|\/embed\/|\/1\/|\/v\/|http.*:\/\/(?:www\.)?youtu\.be\/)([^&\n?#]+)/)) {
                    videoid = matchedResult[1];
                }

                if (matchedResult = decodedUrl.match(/(.+\?)(.+)/)) {
                    urlParameter = matchedResult[2];
                }
                
                //remove  'v=xxxxx' from urlParameter
                urlParameter = urlParameter.replace("v=" + videoid + '&', '').replace("v=" + videoid, '');
                return videoid + (urlParameter != '' ? "?" + urlParameter : '');
            }

            $(videoId).magnificPopup({
                delegate: "a",
                type: "iframe",
                tLoading: "Loading image #%curr%...",
                mainClass: "mfp-img-mobile",
                iframe: {
                    patterns: {
                        youtube: {
                            index: "youtube.com/",
                            id: function (url) {
                                return getVideoIDAndParameterString(url)
                            },
                            src: "//www.youtube.com/embed/%id%"
                        },
                        youtubeShortUrl: {
                            index: "youtu.be/",
                            id: function (url) {
                                return getVideoIDAndParameterString(url)
                            },
                            src: "//www.youtube.com/embed/%id%"
                        }
                    }
                }
            });
        },
        popupImage(imageId) {
            $(imageId).magnificPopup({
                delegate: "a",
                type: "image",
                tLoading: "Loading image #%curr%...",
                mainClass: "mfp-img-mobile",
                gallery: {
                    enabled: true,
                    navigateByImgClick: true,
                    preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
                }
            });
        }
    }
});


// WEBPACK FOOTER //
// ./src/utils/global-mixin.js